

export const rachelReviewerReviewHinge = {
  _id: 'rachelReviewerReviewHingeId',
  email: 'rachel@email.com',
  profileReviewId: 'rachelProfileReviewHingeId',
  reviewerProfileId: 'rachelReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Rachel! This will really help me!',
  profileReviewedFirstName: 'Monica',
}

export const rossReviewerReviewBumble = {
  _id: 'rossReviewerReviewBumbleId',
  email: 'ross@email.com',
  profileReviewId: 'rossProfileReviewBumbleId',
  reviewerProfileId: 'rossReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ross! This will really help me!',
  profileReviewedFirstName: 'Monica',
}

export const joeyReviewerReviewTinder = {
  _id: 'joeyReviewerReviewTinderId',
  email: 'joey@email.com',
  profileReviewId: 'joeyProfileReviewTinderId',
  reviewerProfileId: 'joeyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Joey! This will really help me!',
  profileReviewedFirstName: 'Monica',
}